import { render } from "./WordGenerator.vue?vue&type=template&id=7d307a67&scoped=true"
import script from "./WordGenerator.vue?vue&type=script&lang=js"
export * from "./WordGenerator.vue?vue&type=script&lang=js"

import "./WordGenerator.vue?vue&type=style&index=0&id=7d307a67&scoped=true&lang=css"

import exportComponent from "/Users/vaclavsmital/Projects/geoword/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d307a67"]])

export default __exports__